import {usePermitExtensionSteps} from ".";

const usePermitExtensionProcessUrl = element => {
    const {steps} = usePermitExtensionSteps(element);

    const findPathInSteps = (processSteps, updatedPermit) => {
        return (
            processSteps.find(item => item.status === updatedPermit?.status)?.path ||
            updatedPermit?.status
        );
    };

    const getStepPath = (updatedPermit, basePath) => {
        const path = findPathInSteps(steps, updatedPermit);
        return `${basePath}/application/${path}`;
    };

    return {
        getStepPath,
        findPathInSteps,
    };
};

export {usePermitExtensionProcessUrl};
